import { render, staticRenderFns } from "./nl-NL.vue?vue&type=template&id=1c887cc8&"
import script from "./nl-NL.vue?vue&type=script&lang=js&"
export * from "./nl-NL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c887cc8')) {
      api.createRecord('1c887cc8', component.options)
    } else {
      api.reload('1c887cc8', component.options)
    }
    module.hot.accept("./nl-NL.vue?vue&type=template&id=1c887cc8&", function () {
      api.rerender('1c887cc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/Languages/nl-NL.vue"
export default component.exports